import MultiFilter from './MultiFilter.component';

export default MultiFilter;
